import { useState } from 'react';

import { SettingOutlined } from '@ant-design/icons';
import { Modal as ModalAntD, PageHeader, Result } from 'antd';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { T } from 'react-translator-component';

import * as S from './styled';

import {
  createVirtualGroup,
  createVirtualGroupDynamicPricing,
} from '../../../../hooks/virtualgroup';
import { COLORS } from '../../../molecules/ConnectorColored/helpers';
import { MODULATION_STATIC } from '../../../organisms/SmartChargingForm/fixedPower';
import VirtualGroupForm from '../../../organisms/VirtualGroupForm/VirtualGroupForm';

const Modal: any = ModalAntD;

const VirtualGroupCreatePage = ({ chargePointsList }: any) => {
  const history = useHistory();

  const formValues = useSelector(
    (state: any) => state?.virtualGroup?.formValues,
  );

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState({
    status: false,
    message: '',
  });

  const handleCreateVirtualGroup = async (values: any) => {
    setLoading(true);

    try {
      const response = await createVirtualGroup({
        name: values.name,
        description: values.description,
        charge_boxs: values.charge_boxs.map((chargebox) => ({
          charge_box_id: chargebox.charge_box_id,
        })),
        smart_charging: {
          enabled: values.smart_charging.enabled,
          start_date: values.smart_charging.start_date,
          end_date: values.smart_charging.end_date,
          current_nominal_a: values.smart_charging.current_nominal_a,
          algorithm: values.smart_charging.algorithm,
          // MV2-2005: potência fixa não usa medidor; o modo e as potências vêm do VirtualGroupForm
          meter_device_remote_id:
            values.smart_charging.modulation === MODULATION_STATIC
              ? null
              : values.smart_charging.meter_device?.device_remote_id,
          meter_device_remote_in_circuit: true,
          modulation: values.smart_charging.modulation,
          connector_powers: values.smart_charging.connector_powers,
        },
        dynamic_pricing: {
          enabled: Boolean(values.dynamic_pricing?.enabled),
          connector1_dynamic_pricing_id:
            values.dynamic_pricing?.connector1_dynamic_pricing_id,
          connector2_dynamic_pricing_id:
            values.dynamic_pricing?.connector2_dynamic_pricing_id,
          connector3_dynamic_pricing_id:
            values.dynamic_pricing?.connector3_dynamic_pricing_id,
        },
      });

      if (response?.data?.dynamic_pricing?.virtual_group_id) {
        await createVirtualGroupDynamicPricing({
          virtual_group_id: response.data.dynamic_pricing.virtual_group_id,
          enabled: values.dynamic_pricing.enabled,
          connector1_dynamic_pricing_id:
            values.dynamic_pricing.connector1_dynamic_pricing_id,
          connector2_dynamic_pricing_id:
            values.dynamic_pricing.connector2_dynamic_pricing_id,
          connector3_dynamic_pricing_id:
            values.dynamic_pricing.connector3_dynamic_pricing_id,
        });
      }

      setSuccess(true);
    } catch (e: any) {
      setTimeout(
        () =>
          setError({
            status: true,
            message:
              e?.response?.data.split(':')[1].trim() ===
              'Não foi possível criar SmartCharging, Grupo Virtual contém carregadores inválidos'
                ? 'Não foi possível criar a configuração avançada porque contém carregadores com dados inválidos.'
                : 'Não foi possível criar a configuração!',
          }),
        1500,
      );
    } finally {
      setTimeout(() => setLoading(false), 1500);
    }
  };

  return (
    <>
      <S.Wrapper>
        <PageHeader
          onBack={() => history.push('/virtual-groups')}
          title={
            <>
              <SettingOutlined
                style={{ position: 'relative', marginRight: 16 }}
                color={COLORS.black}
                height={20}
                width={20}
              />

              {T('Create Configuration')}
            </>
          }
        />

        <S.Blank>
          <VirtualGroupForm
            initialValues={{
              ...formValues,
            }}
            loading={loading}
            chargePointsList={chargePointsList}
            onSubmit={handleCreateVirtualGroup}
          />
        </S.Blank>
      </S.Wrapper>

      <Modal
        visible={success}
        onOk={() => {}}
        onCancel={() => {}}
        closable={false}
        footer={null}
      >
        <Result
          status='success'
          title='Configuração cadastrada com sucesso!'
          extra={[
            <S.Button
              type='primary'
              key='console'
              size='large'
              onClick={() => {
                history.push('/virtual-groups');
              }}
            >
              Ver listagem atualizada
            </S.Button>,
          ]}
        />
      </Modal>
      <Modal visible={error.status} closable={false} footer={null}>
        <Result
          status='error'
          title={error.message}
          extra={[
            <S.Button
              key='default'
              size='large'
              onClick={() => {
                setError({
                  status: false,
                  message: '',
                });

                history.push('/virtual-groups');
              }}
            >
              Ver listagem
            </S.Button>,
            <S.Button
              type='primary'
              key='primary'
              size='large'
              onClick={() =>
                setError({
                  status: false,
                  message: '',
                })
              }
            >
              Tentar novamente
            </S.Button>,
          ]}
        />
      </Modal>
    </>
  );
};

export default VirtualGroupCreatePage;
